export enum ReadOnlyAccessTypeEnum {
  BOARD_ACCESS = "BOARD_ACCESS",
}
